module.exports = __webpack_public_path__ + "img/pie_bg.22bced56.png";